import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import {insertItem, updateObjectInArray} from "./helpers";

export default function applicationaReducer(
  state = initialState.applications,
  action
) {
  switch (action.type) {
    case types.LOAD_APPLICATIONS_SUCCESS:
      return action.applications;
    case types.SAVE_APPLICATION_SUCCESS:
      return insertItem(state, action.application);
      case types.UPDATE_APPLICATION_SUCCESS:
      return updateObjectInArray(state, action.application);
    case types.DELETE_APPLICATION_SUCCESS:
      return state.filter((item) => item.id !== action.id);
    default:
      return state;
  }
}
